export enum EVENT_TYPE {
  ERROR = "ERROR",
  MESSAGE = "MESSAGE",
  ACTION = "ACTION",
}
